import { ProgressCircle } from '@americanexpress/dls-react';
import { withRouter } from '@americanexpress/one-app-router';
import { preload, setLogoffAlert } from '@americanexpress/one-identity-ducks';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getLoginUrl, getTargetAllowList } from '../selectors';
import styles from './styles.scss';

const findQueryParam = (query, param) => query[
  Object.keys(query).find((key) => key.toLowerCase() === param.toLowerCase())
];

export const Logout = ({
  targetAllowListRaw, loginUrl, location: { query }, router: { replace },
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [entryPointData, setEntryPointData] = useState(null);
  useEffect(() => {
    if (isAuthenticated) {
      (() => {
        setLogoffAlert(query.type || 'logoff');
        preload();

        if (global.BROWSER && window && localStorage.entryPointData) {
          setEntryPointData(JSON.parse(localStorage.entryPointData));
        }
        setIsAuthenticated(false);
      })();
    } else {
      const target = findQueryParam(query, 'destPage') // rediect user to destPage if it exists eg. logout?DestPage=
        || findQueryParam(query, 'target') // rediect user to target if it exists eg. logout?Target=
        || entryPointData?.entryURL // logout user back to entryURL if it exists this is a full URL eg. https://www.americanexpress.com/en-us/login?target=
        || loginUrl; // default URL regular login URL eg. americanexpress.com/en-us/account/login
      if (window && target.toLowerCase().startsWith('http')) {
        const targetAllowList = JSON.parse(targetAllowListRaw); // list from provideStateConfig targetAllowList -- Part of global config state
        const decodeTargetURL = decodeURIComponent(target); // decode for find
        const targetURL = new URL(decodeTargetURL); // create URL object
        const targetOrg = targetURL.origin; // get domain

        // check if target is in the allow list
        // targetAllowList is in provideStateConfig
        if (targetAllowList.find(
          (allowedUrl) => targetOrg.startsWith('https://')
            && (targetOrg.endsWith(`.${allowedUrl}`) || targetOrg.endsWith(`/${allowedUrl}`)))
        ) {
          window.location.replace(target);
        } else {
          window.location.replace(loginUrl);
        }
      } else {
        replace(target);
      }
    }
  }, [isAuthenticated]);

  return (
    <div data-testid="progress-circle" className={`flex flex-justify-center flex-align-center ${styles.viewHeight}`}>
      <ProgressCircle size="lg" />
    </div>
  );
};

Logout.propTypes = {
  targetAllowListRaw: PropTypes.string.isRequired,
  loginUrl: PropTypes.string.isRequired,
  location: PropTypes.shape({
    query: PropTypes.shape({
      type: PropTypes.string,
    }).isRequired,
  }).isRequired,
  router: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

export const ComponentUnderTest = Logout;

export default compose(
  withRouter,
  connect((state) => ({
    loginUrl: getLoginUrl(state),
    targetAllowListRaw: getTargetAllowList(state),
  }))
)(Logout);
